<template>
    <div class="alm-items-button-wrapper">
        <span class="deploy-btn" :class="{'is-deployed-disabled': isButtonDisabled}" role="button" @click="handleDeploy($event)">{{localizer.Localize('LandscapeManagement_Deploy_Text')}}</span>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Localizer } from "@/api/Localizer";
import { isButtonDisabled } from "@/components/pages/landscape/AlmUtils";

export default defineComponent({
    props: {
        params: Object,
    },
    data() {
        return {
            localizer: new Localizer(this.$store),
        };
    },
    computed: {
        status() {
            return this.params?.data?.status || "";
        },
        isButtonDisabled() {
            return isButtonDisabled(this.status);
        }
    },
    methods: {
        handleDeploy(event: MouseEvent) {
            if (!this.isButtonDisabled) {
                event.stopPropagation();
                this.params?.onDeploy(this.params?.data);
            }
        },
    },
});
</script>

<style>
.alm-items-button-wrapper {
    height: 100%;
}

.alm-items-button-wrapper .deploy-btn {
    border-right: 1px solid #e6ebf8;
    color: var(--accent-color);
    padding-right: 16px;
    font-weight: 600; 
    cursor: pointer;
}

.alm-items-button-wrapper .is-deployed-disabled {
    opacity: 0.6;
    cursor: default;
    color: var(--foreground-primary);
}
</style>
